import "./App.css";
import Method from "./Method";
import { useMemo, useState } from "react";
import { calculateDoomsday, MONTH_NAMES } from "./doomsday";

const toIsoDate = (year, month, day) =>
  `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;

const daysInMonth = (year, month) => new Date(year, month, 0).getDate();

const randomInt = (min, max) =>
  Math.floor(Math.random() * (max - min + 1)) + min;

const randomDateInYearRange = (minYear, maxYear) => {
  const year = randomInt(minYear, maxYear);
  const month = randomInt(1, 12);
  const day = randomInt(1, daysInMonth(year, month));
  return [year, month, day];
};

function App({ todaysDate }) {
  // let doomsdays = {
  //   0: 3,
  //   1: 28,
  //   2: 14,
  //   3: 4,
  //   4: 9,
  //   5: 6,
  //   6: 11,
  //   7: 8,
  //   8: 5,
  //   9: 10,
  //   10: 7,
  //   11: 12,
  // };

  const thisYear = todaysDate.getFullYear();
  const thisMonth = todaysDate.getMonth() + 1;
  const thisDay = todaysDate.getDate();

  const [[year, month, day], setDate] = useState([
    thisYear,
    thisMonth,
    thisDay,
  ]);
  const [dateChanged, setDateChanged] = useState(false);
  const [dateRevealed, setDateRevealed] = useState(false);
  const [yearRange, setYearRange] = useState({ min: 1900, max: 2180 });
  const [monthMethod, setMonthMethod] = useState("monthNeg");
  const [explainMode, setExplainMode] = useState(false);

  const details = useMemo(
    () =>
      calculateDoomsday({
        year,
        month,
        day,
        method: monthMethod,
      }),
    [year, month, day, monthMethod]
  );

  const applyRandomDate = (nextDate) => {
    setDate(nextDate);
    setDateChanged(true);
    setDateRevealed(false);
  };

  const randomDateThisYear = () => {
    applyRandomDate(randomDateInYearRange(thisYear, thisYear));
  };

  const randomDateInRange = () => {
    const minYear = Math.min(yearRange.min, yearRange.max);
    const maxYear = Math.max(yearRange.min, yearRange.max);
    applyRandomDate(randomDateInYearRange(minYear, maxYear));
  };

  return (
    <div className="App">
      <section className="panel primary">
        <div className="date-display">
          <p className="datestate">
            {dateChanged ? "Selected date" : "Today"} is
          </p>
          <p className="chosendate">
            {day} {MONTH_NAMES[month - 1]} {year}
          </p>
        </div>
        <div className="controls">
          <label className="field">
            Pick a date
            <input
              type="date"
              value={toIsoDate(year, month, day)}
              onChange={(e) => {
                setDateChanged(true);
                setDateRevealed(false);
                const date = new Date(e.target.value);
                setDate([
                  date.getFullYear(),
                  date.getMonth() + 1,
                  date.getDate(),
                ]);
              }}
            ></input>
          </label>
          <div className="randomdate-controls">
            <button className="randomdate" onClick={randomDateThisYear}>
              RANDOM (THIS YEAR)
            </button>
            <button className="randomdate" onClick={randomDateInRange}>
              RANDOM (RANGE)
            </button>
          </div>
          <div className="yearrange">
            <label className="field">
              From year
              <input
                type="number"
                value={yearRange.min}
                onChange={(e) =>
                  setYearRange((current) => ({
                    ...current,
                    min: Number(e.target.value),
                  }))
                }
              />
            </label>
            <label className="field">
              To year
              <input
                type="number"
                value={yearRange.max}
                onChange={(e) =>
                  setYearRange((current) => ({
                    ...current,
                    max: Number(e.target.value),
                  }))
                }
              />
            </label>
          </div>
        </div>
      </section>

      <section className="panel reveal">
        <p className="reveal-help">
          Click to reveal the weekday, then verify it with the method below.
        </p>
        <div
          className={dateRevealed ? "dayofweek shown" : "dayofweek hidden"}
          onClick={() => {
            setDateRevealed(true);
          }}
        >
          {details.weekdayName}
        </div>
        {explainMode && (
          <div className="explain-panel">
            <p>
              Century anchor: {details.anchor} (century {details.century})
            </p>
            <p>
              Year doomsday: {details.doomsday} ({details.doomsdayName})
            </p>
            <p>
              Month offset ({monthMethod === "standard" ? "standard" : "month neg"}
              ): {details.offset}
            </p>
            {details.leapAdjustment ? (
              <p>Leap adjustment applied: -1 (Jan/Feb)</p>
            ) : (
              <p>No leap adjustment needed</p>
            )}
            <p>Final weekday index: {details.weekdayIndex}</p>
            <p>Final weekday: {details.weekdayName}</p>
          </div>
        )}
        <label className="explain-toggle">
          <input
            type="checkbox"
            checked={explainMode}
            onChange={(e) => setExplainMode(e.target.checked)}
          />
          Explain this result
        </label>
      </section>

      <section className="panel method-panel">
        <Method
          details={details}
          monthMethod={monthMethod}
          setMonthMethod={setMonthMethod}
        />
      </section>
    </div>
  );
}

export default App;
